import React, { useState } from 'react';
import { PlusIcon, TrashIcon, InfoIcon, LayoutGridIcon, ListIcon } from 'lucide-react';
export function PivotSelectionStep({
  initialData = [],
  onUpdate
}) {
  const [pivots, setPivots] = useState(initialData.length ? initialData : [{
    name: '',
    length: 400,
    area: 50,
    degrees: 360,
    tradername: 'Western',
    model: 'CP600',
    price: 65000
  }]);
  const [viewMode, setViewMode] = useState('list'); // "list" or "grid"
  const handleAddPivot = () => {
    const newPivot = {
      name: '',
      length: 400,
      area: 50,
      degrees: 360,
      tradername: 'Western',
      model: 'CP600',
      price: 60000
    };
    setPivots([...pivots, newPivot]);
    onUpdate([...pivots, newPivot]);
  };
  const handleRemovePivot = index => {
    const newPivots = pivots.filter((_, i) => i !== index);
    setPivots(newPivots);
    onUpdate(newPivots);
  };
  const handlePivotChange = (index, field, value) => {
    const newPivots = [...pivots];
    newPivots[index] = {
      ...newPivots[index],
      [field]: value
    };
    // Auto calculate area based on length and degrees
    if (field === 'length' || field === 'degrees') {
      const lengthInMeters = parseFloat(newPivots[index].length);
      const degrees = parseFloat(newPivots[index].degrees);
      const areaHa = Math.round(Math.PI * Math.pow(lengthInMeters, 2) * (degrees / 360) / 10000);
      newPivots[index].area = areaHa;
    }
    // Auto adjust price based on model and length
    if (field === 'model' || field === 'length') {
      const basePrice = field === 'model' && value === '8120' ? 70000 : 60000;
      const lengthFactor = newPivots[index].length / 400; // Adjust price based on length
      newPivots[index].price = Math.round(basePrice * lengthFactor);
    }
    setPivots(newPivots);
    onUpdate(newPivots);
  };
  return <div className="space-y-6" data-id="element-4298">
      <div className="flex justify-between items-center" data-id="element-4299">
        <div className="text-white text-xl font-medium" data-id="element-4300">
          Select Pivot Machines
        </div>
        <div className="flex bg-slate-800/50 rounded-lg p-1" data-id="element-4301">
          <button className={`p-2 rounded ${viewMode === 'list' ? 'bg-blue-600 text-white' : 'text-blue-300 hover:text-white'}`} onClick={() => setViewMode('list')} data-id="element-4302">
            <ListIcon size={18} data-id="element-4303" />
          </button>
          <button className={`p-2 rounded ${viewMode === 'grid' ? 'bg-blue-600 text-white' : 'text-blue-300 hover:text-white'}`} onClick={() => setViewMode('grid')} data-id="element-4304">
            <LayoutGridIcon size={18} data-id="element-4305" />
          </button>
        </div>
      </div>

      <div className="bg-blue-900/30 rounded-xl p-5 border border-blue-800/30 mb-6" data-id="element-4306">
        <div className="flex items-start" data-id="element-4307">
          <InfoIcon size={20} className="text-blue-400 mr-3 mt-0.5" data-id="element-4308" />
          <div data-id="element-4309">
            <h3 className="text-white font-medium mb-1" data-id="element-4310">
              Pivot Selection Guide
            </h3>
            <p className="text-blue-200 text-sm" data-id="element-4311">
              Select the pivot machines you want to include in this quote. You
              can add multiple pivots with different specifications. The system
              will automatically calculate coverage area based on length and
              degrees.
            </p>
          </div>
        </div>
      </div>

      {viewMode === 'list' ?
    // List View
    <div className="bg-slate-800/50 rounded-xl border border-blue-800/30" data-id="element-4312">
          <div className="grid grid-cols-12 gap-4 p-4 border-b border-blue-800/30 text-sm font-medium text-blue-300" data-id="element-4313">
            <div className="col-span-2" data-id="element-4314">Pivot Name</div>
            <div className="col-span-1 text-center" data-id="element-4315">Length (m)</div>
            <div className="col-span-1 text-center" data-id="element-4316">Area (ha)</div>
            <div className="col-span-1 text-center" data-id="element-4317">Degrees</div>
            <div className="col-span-2" data-id="element-4318">Tradername</div>
            <div className="col-span-2" data-id="element-4319">Model</div>
            <div className="col-span-2 text-right pr-8" data-id="element-4320">Price</div>
            <div className="col-span-1" data-id="element-4321"></div>
          </div>
          <div className="p-2" data-id="element-4322">
            {pivots.map((pivot, index) => <div key={index} className="grid grid-cols-12 gap-4 p-2 items-center" data-id="element-4323">
                <div className="col-span-2" data-id="element-4324">
                  <input type="text" value={pivot.name} onChange={e => handlePivotChange(index, 'name', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Pivot name" data-id="element-4325" />
                </div>
                <div className="col-span-1" data-id="element-4326">
                  <input type="number" value={pivot.length} onChange={e => handlePivotChange(index, 'length', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-center" min="100" max="1000" step="1" data-id="element-4327" />
                </div>
                <div className="col-span-1" data-id="element-4328">
                  <input type="number" value={pivot.area} onChange={e => handlePivotChange(index, 'area', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-center" min="1" readOnly data-id="element-4329" />
                </div>
                <div className="col-span-1" data-id="element-4330">
                  <input type="number" value={pivot.degrees} onChange={e => handlePivotChange(index, 'degrees', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-center" min="1" max="360" step="1" data-id="element-4331" />
                </div>
                <div className="col-span-2" data-id="element-4332">
                  <select value={pivot.tradername} onChange={e => handlePivotChange(index, 'tradername', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '16px'
            }} data-id="element-4333">
                    <option value="Western" data-id="element-4334">Western</option>
                    <option value="Pierce" data-id="element-4335">Pierce</option>
                  </select>
                </div>
                <div className="col-span-2" data-id="element-4336">
                  <select value={pivot.model} onChange={e => handlePivotChange(index, 'model', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '16px'
            }} data-id="element-4337">
                    <option value="CP600" data-id="element-4338">CP600</option>
                    <option value="8120" data-id="element-4339">8120</option>
                  </select>
                </div>
                <div className="col-span-2" data-id="element-4340">
                  <div className="relative" data-id="element-4341">
                    <span className="absolute left-3 top-2 text-gray-400" data-id="element-4342">
                      $
                    </span>
                    <input type="number" value={pivot.price} onChange={e => handlePivotChange(index, 'price', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg pl-7 pr-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-right" min="0" step="100" data-id="element-4343" />
                  </div>
                </div>
                <div className="col-span-1 flex justify-center" data-id="element-4344">
                  {pivots.length > 1 && <button onClick={() => handleRemovePivot(index)} className="p-1.5 rounded-full bg-red-500/20 text-red-400 hover:bg-red-500/40 hover:text-white transition-colors" data-id="element-4345">
                      <TrashIcon size={16} data-id="element-4346" />
                    </button>}
                </div>
              </div>)}
          </div>
          <div className="p-4 border-t border-blue-800/30" data-id="element-4347">
            <button onClick={handleAddPivot} className="w-full py-2.5 rounded-lg border border-dashed border-blue-500/50 bg-blue-900/20 text-blue-400 hover:bg-blue-900/30 hover:text-blue-300 transition-colors flex items-center justify-center" data-id="element-4348">
              <PlusIcon size={18} className="mr-2" data-id="element-4349" />
              Add Another Pivot
            </button>
          </div>
        </div> :
    // Grid View
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4350">
          {pivots.map((pivot, index) => <div key={index} className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30 relative" data-id="element-4351">
              {pivots.length > 1 && <button onClick={() => handleRemovePivot(index)} className="absolute top-4 right-4 p-1.5 rounded-full bg-red-500/20 text-red-400 hover:bg-red-500/40 hover:text-white transition-colors" data-id="element-4352">
                  <TrashIcon size={16} data-id="element-4353" />
                </button>}
              <h3 className="text-white font-medium mb-4" data-id="element-4354">Pivot {index + 1}</h3>
              <div className="grid grid-cols-1 gap-4 mb-4" data-id="element-4355">
                <div data-id="element-4356">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4357">
                    Pivot Name
                  </label>
                  <input type="text" value={pivot.name} onChange={e => handlePivotChange(index, 'name', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter pivot name" data-id="element-4358" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-4359">
                <div data-id="element-4360">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4361">
                    Tradername
                  </label>
                  <select value={pivot.tradername} onChange={e => handlePivotChange(index, 'tradername', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '20px'
            }} data-id="element-4362">
                    <option value="Western" data-id="element-4363">Western</option>
                    <option value="Pierce" data-id="element-4364">Pierce</option>
                  </select>
                </div>
                <div data-id="element-4365">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4366">
                    Model
                  </label>
                  <select value={pivot.model} onChange={e => handlePivotChange(index, 'model', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '20px'
            }} data-id="element-4367">
                    <option value="CP600" data-id="element-4368">CP600</option>
                    <option value="8120" data-id="element-4369">8120</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 mb-4" data-id="element-4370">
                <div data-id="element-4371">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4372">
                    Length (m)
                  </label>
                  <input type="number" value={pivot.length} onChange={e => handlePivotChange(index, 'length', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" min="100" max="1000" step="1" data-id="element-4373" />
                </div>
                <div data-id="element-4374">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4375">
                    Area (ha)
                  </label>
                  <input type="number" value={pivot.area} onChange={e => handlePivotChange(index, 'area', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 bg-slate-800/70" min="1" readOnly data-id="element-4376" />
                  <div className="text-xs text-blue-400 mt-1" data-id="element-4377">
                    Auto-calculated
                  </div>
                </div>
                <div data-id="element-4378">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4379">
                    Degrees
                  </label>
                  <input type="number" value={pivot.degrees} onChange={e => handlePivotChange(index, 'degrees', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" min="1" max="360" step="1" data-id="element-4380" />
                </div>
              </div>
              <div data-id="element-4381">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-4382">
                  Price
                </label>
                <div className="relative" data-id="element-4383">
                  <span className="absolute left-4 top-2.5 text-gray-400" data-id="element-4384">
                    $
                  </span>
                  <input type="number" value={pivot.price} onChange={e => handlePivotChange(index, 'price', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg pl-8 pr-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" min="0" step="100" data-id="element-4385" />
                </div>
              </div>
            </div>)}
          <button onClick={handleAddPivot} className="h-full min-h-[200px] rounded-xl border border-dashed border-blue-500/50 bg-blue-900/20 text-blue-400 hover:bg-blue-900/30 hover:text-blue-300 transition-colors flex flex-col items-center justify-center" data-id="element-4386">
            <PlusIcon size={24} className="mb-2" data-id="element-4387" />
            <span data-id="element-4388">Add Another Pivot</span>
          </button>
        </div>}

      {/* Total section */}
      <div className="flex justify-end" data-id="element-4389">
        <div className="bg-slate-800/50 rounded-xl p-4 border border-blue-800/30 w-64" data-id="element-4390">
          <div className="flex justify-between items-center text-blue-300 mb-2" data-id="element-4391">
            <span data-id="element-4392">Subtotal:</span>
            <span className="text-white" data-id="element-4393">
              $
              {pivots.reduce((sum, pivot) => sum + (pivot.price || 0), 0).toFixed(2)}
            </span>
          </div>
          <div className="border-t border-blue-800/30 pt-2 mt-2" data-id="element-4394">
            <div className="flex justify-between items-center" data-id="element-4395">
              <span className="font-medium text-white" data-id="element-4396">Total:</span>
              <span className="text-xl font-bold text-white" data-id="element-4397">
                $
                {pivots.reduce((sum, pivot) => sum + (pivot.price || 0), 0).toFixed(2)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}